import type { GetOrganisationsQuery, GetOrganisationsResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_ORGANISATIONS_LIMIT = 50

function getOrganisations(query: GetOrganisationsQuery): Promise<GetOrganisationsResponse> {
  return requestApiJsonOrThrow<GetOrganisationsResponse>('admin/organisations', {
    params: query,
  })
}

export const organisationsQuery = (queryParams: GetOrganisationsQuery) => ({
  queryKey: ['organisations', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getOrganisations({
      limit: GET_ORGANISATIONS_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetOrganisationsResponse, pages: GetOrganisationsResponse[]) => {
    if (lastPage.data.length < GET_ORGANISATIONS_LIMIT) return
    return pages.length * GET_ORGANISATIONS_LIMIT
  },
})
